import { useAddCommentOnPropertyMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useAddCommentOnProperty = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useAddCommentOnPropertyMutation(headerWithAuth, options);

  return mutate;
};

export {
  useAddCommentOnProperty,
};
